import { NodeProps } from '../../../../types.ts';
import CustomNode from './CustomNode.tsx';
import { Edge, Node } from 'reactflow';
import { MergeConfiguration, WorkflowNode } from '../../../../api/model.ts';

const MergeNode = (props: NodeProps) => {
  return <CustomNode {...props} />;
};

export function updateMergeNodeConfig(node: Node<WorkflowNode>, edges: Edge[]): Node {
  if (node.type !== 'merge') return node;

  const configuration = node.data.configuration as MergeConfiguration;
  if (configuration?.strategy !== 'join') return node;

  const incomingEdges = edges.filter((edge) => edge.target === node.id);
  const predecessors = new Set(incomingEdges.map((e) => e.source));

  const newJoinOrder = (configuration.join_order ?? []).filter((joinConfig) => predecessors.has(joinConfig.node_id));

  const missing = [...predecessors].filter((id) => !newJoinOrder.find((c) => c.node_id === id));

  const newPredecessors = missing.map((id) => ({
    node_id: id,
    column: '',
  }));

  return {
    ...node,
    data: {
      ...node.data,
      configuration: {
        ...configuration,
        join_order: [...newJoinOrder, ...newPredecessors],
      },
    },
  };
}

export default MergeNode;
